// 네이버 블로그 글 링크 — 클라이언트/서버 공용
// section: pricing(시세 정보 페이지 아래 "시세 관련 블로그") / blog(홈 블로그 섹션·블로그 목록)
export const SITE_ASSETS_BUCKET = 'site-assets';
export const PRICING_BLOG_FOLDER = 'pricing-blog';

export const LINK_SECTIONS = ['pricing', 'blog'] as const;
export type LinkSection = (typeof LINK_SECTIONS)[number];
export function parseSection(v: unknown): LinkSection {
  return v === 'blog' ? 'blog' : 'pricing';
}

export type PricingBlogLink = {
  id: string;
  section: LinkSection;
  url: string;
  title: string;
  excerpt: string;
  category: string;
  post_date: string | null;
  image_path: string | null;
  is_visible: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
};

export const PRICING_BLOG_SELECT =
  'id, section, url, title, excerpt, category, post_date, image_path, is_visible, sort_order, created_at, updated_at';

export function siteAssetUrl(path: string) {
  const base = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';
  const encoded = path.split('/').map(encodeURIComponent).join('/');
  return `${base}/storage/v1/object/public/${SITE_ASSETS_BUCKET}/${encoded}`;
}
